import {
    createRequestTypes,
    START,
    SUCCESS,
    ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';
import * as api from '../api/runs';

const namespace = 'AUDITS';

export const FETCH_EXEMPTION_AUDIT_RUNS = createRequestTypes(
    `${namespace}/FETCH_EXEMPTION_AUDIT_RUNS`,
);

export const fetchExemptionAuditRuns = makeApiActionCreatorV3(
    api.fetchExemptionAuditRuns,
    FETCH_EXEMPTION_AUDIT_RUNS[START],
    FETCH_EXEMPTION_AUDIT_RUNS[SUCCESS],
    FETCH_EXEMPTION_AUDIT_RUNS[ERROR],
);

export const CREATE_EXEMPTION_AUDIT_RUNS = createRequestTypes(
    `${namespace}/CREATE_EXEMPTION_AUDIT_RUNS`,
);

export const createExemptionAuditRuns = makeApiActionCreatorV3(
    api.createExemptionAuditRuns,
    CREATE_EXEMPTION_AUDIT_RUNS[START],
    CREATE_EXEMPTION_AUDIT_RUNS[SUCCESS],
    CREATE_EXEMPTION_AUDIT_RUNS[ERROR],
);
